// extracted by mini-css-extract-plugin
module.exports = {"word":"Word_word__2fIca","scholar":"Word_scholar__Nntbt","challenger":"Word_challenger__ECMnW","input":"Word_input__XGJpv"};